import firebase from "firebase";
import { db } from "../db";
import Events from "./Events";

const COLLECTION = "SurveyStats";

function recordAssignment(surveyId, testerId) {
  if (!surveyId || !testerId) return Promise.resolve({ success: false });

  return db
    .collection(COLLECTION)
    .doc(surveyId)
    .set({ assignedIds: { [testerId]: true } }, { merge: true })
    .then(() => {
      Events.logEvent("benchmark.updated", { surveyId, change: "assigned" });
      return { success: true };
    })
    .catch((e) => {
      console.error(`recordAssignment(${surveyId}) failed:`, e);
      return { success: false, error: e };
    });
}

function recordResponse(surveyId, testerId, answers) {
  if (!surveyId || !testerId) return Promise.resolve({ success: false });

  return db
    .collection(COLLECTION)
    .doc(surveyId)
    .set(
      {
        respondentIds: { [testerId]: true },
        responses: firebase.firestore.FieldValue.increment(1),
        lastResponseAt: firebase.firestore.FieldValue.serverTimestamp(),
      },
      { merge: true }
    )
    .then(() => {
      Events.logEvent("benchmark.updated", {
        surveyId,
        change: "response",
        answers: Array.isArray(answers) ? answers.length : null,
      });
      return { success: true };
    })
    .catch((e) => {
      console.error(`recordResponse(${surveyId}) failed:`, e);
      return { success: false, error: e };
    });
}

export default {
  recordAssignment,
  recordResponse,
};



// WEBPACK FOOTER //
// ./src/Firestore/Benchmarks.js